import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { View, TouchableOpacity, Animated } from 'react-native';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
import { AnimatedImageView } from '../Image/AnimatedImageView';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
export const TabView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.tab,
    style: (theme, mediaQuery, window, props) => {
        var _a, _b;
        return {
            text: Object.assign({ textAlign: 'center' }, mediaQuery.md({
                textAlign: undefined
            })),
            tab: Object.assign(Object.assign({ paddingBottom: 13, paddingHorizontal: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', marginHorizontal: 0 }, mediaQuery.md({
                marginHorizontal: undefined
            })), props.containerStyle),
            tabIcon: {
                paddingEnd: 10
            },
            tabTitle: Object.assign({ fontSize: 14, fontWeight: 'bold', color: props.light
                    ? '#fff'
                    : 'rgb(99, 120, 143)' }, props.textStyle),
            activeTab: {
                borderRadius: 3,
                height: 3,
                backgroundColor: props.light
                    ? '#fff'
                    : ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.secondary_color) || '#1155CC',
            },
            activeTabTitle: {
                color: props.light
                    ? '#fff'
                    : ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.secondary_color) || 'rgb(17, 85, 204)'
            },
            container: {}
        };
    }
})(({ style, testID, onPress, value, isActive }) => {
    var _a, _b, _c, _d;
    const animation = useRef(new Animated.Value(isActive ? 1 : 0)).current;
    useEffect(() => {
        Animated.timing(animation, {
            useNativeDriver: false,
            toValue: isActive
                ? 1
                : 0,
            duration: 200
        }).start();
    }, [isActive]);
    const handlePress = useCallback(() => {
        return onPress === null || onPress === void 0 ? void 0 : onPress(value);
    }, [onPress, value]);
    const color = animation.interpolate({
        inputRange: [0, 1],
        outputRange: [
            ((_a = style === null || style === void 0 ? void 0 : style.tabTitle) === null || _a === void 0 ? void 0 : _a.color) || 'rgb(99, 120, 143)',
            ((_b = style === null || style === void 0 ? void 0 : style.activeTabTitle) === null || _b === void 0 ? void 0 : _b.color) || 'rgb(17, 85, 204)'
        ]
    });
    return (_jsxs(TouchableOpacity, { testID: `tab-${testID || value.testID || value.tag || value.title}`, activeOpacity: 1, style: style === null || style === void 0 ? void 0 : style.container, onPress: handlePress, children: [_jsxs(View, { style: style === null || style === void 0 ? void 0 : style.tab, children: [(!!value.image || !!value.icon) && (_jsx(View, { style: style === null || style === void 0 ? void 0 : style.tabIcon, children: _jsx(AnimatedImageView, { image: value.image, icon: value.icon, containerStyle: { width: 20, height: 20 }, fill: isActive
                                ? ((_c = style === null || style === void 0 ? void 0 : style.activeTabTitle) === null || _c === void 0 ? void 0 : _c.color) || 'rgb(17, 85, 204)'
                                : ((_d = style === null || style === void 0 ? void 0 : style.tabTitle) === null || _d === void 0 ? void 0 : _d.color) || 'rgb(99, 120, 143)' }) })), _jsx(AnimatedTextView, { textStyle: [style === null || style === void 0 ? void 0 : style.text, style === null || style === void 0 ? void 0 : style.tabTitle, { color }], children: value.title })] }), _jsx(Animated.View, { style: Object.assign({ opacity: animation }, style === null || style === void 0 ? void 0 : style.activeTab) })] }));
});
